module.exports = __webpack_public_path__ + "assets/ziyuan_4.01741e0c.svg";